import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import RefferalsList from "./RefferalsList";

export default {
  list: RefferalsList,
  icon: SupervisedUserCircleIcon,
};
